// i18next-extract-mark-ns-start case-studies

import { graphql } from 'gatsby'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import * as React from 'react'
import CaseStudiesGridItem from 'src/components/sections/caseStudies/CaseStudiesGridItem'
import ContactSection from 'src/components/sections/ContactSection'
import { directusFileUrl } from 'src/helpers/directus'
import { GLOBAL_PREVIEW_MODE, reorderCasesForPreview, getCaseStudyCoverUrl } from 'src/helpers/preview'
import Layout from '../components/layout'
import Hero from '../components/sections/hero'

const IndexPage = ({ data }: any) => {
  const { t } = useTranslation('case-studies')

  const cases = data?.directus?.cases || []

  const casesList = reorderCasesForPreview(cases).filter((item: any) => item?.t?.length > 0)

  const metas = []
  return (
    <Layout title={t('Case studies')} metas={metas} isSideNavHidden>
      <Hero
        translationContent={{
          sectionName: t('sectionName'),
          subtitle: t('subtitle'),
          firstPartOfTitle: t('firstPartOfTitle'),
          secondPartOfTitle: t('secondPartOfTitle'),
          content: t('Overview of case studies'),
          ctaLink: '#case-studies',
          ctaText: t('ctaText'),
        }}
      />

      <div id="case-studies" className="container py-10 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-12 gap-y-16">
          {casesList.map((caseStudy, index) => {
            const translation = caseStudy?.t?.[0] || {}
            const {
              firstPartOfTitle = '',
              secondPartOfTitle = '',
              contentHeader = '',
              excerpt = '',
            } = translation

            let span = ''
            let isFullWidth = false

            const totalItems = casesList.length
            const isOdd = totalItems % 2 !== 0

            if (isOdd && index === totalItems - 1) {
              span = 'md:col-span-12'
              isFullWidth = true
            } else {
              const pairIndex = Math.floor(index / 2)
              const isFirstInPair = index % 2 === 0
              if (pairIndex % 2 === 0) {
                span = isFirstInPair ? 'md:col-span-5' : 'md:col-span-7'
              } else {
                span = isFirstInPair ? 'md:col-span-7' : 'md:col-span-5'
              }
            }

            return (
              <CaseStudiesGridItem
                key={caseStudy.id}
                title={contentHeader || ''}
                subtitle={excerpt || ''}
                firstPartOfTitle={firstPartOfTitle}
                secondPartOfTitle={secondPartOfTitle}
                tags={caseStudy.platforms || []}
                ctaLink={`/case-studies${caseStudy.slug}`}
                className={span}
                isFullWidth={isFullWidth}
                image={{
                  url: !GLOBAL_PREVIEW_MODE && caseStudy.desktopImage?.id
                    ? directusFileUrl(caseStudy.desktopImage.id)
                    : getCaseStudyCoverUrl(caseStudy),
                  alt: `${firstPartOfTitle} ${secondPartOfTitle}`,
                }}
                detailImage={
                  !GLOBAL_PREVIEW_MODE && caseStudy.detailsDesktopImage?.id
                    ? {
                        url: directusFileUrl(caseStudy.detailsDesktopImage.id),
                        alt: `${firstPartOfTitle} ${secondPartOfTitle}`,
                      }
                    : undefined
                }
              />
            )
          })}
        </div>
      </div>
      <ContactSection />
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    directus {
      cases: case_study(sort: "sort") {
        id
        slug
        platforms
        t: translations(
          filter: { languages_id: { code: { _eq: $language } } }
        ) {
          contentHeader: content_header
          excerpt
          subtitle
          firstPartOfTitle: title_part_1
          secondPartOfTitle: title_part_2
          ctaText: link_text
          languages_id {
            code
          }
        }
        desktopImage: desktop_image {
          id
        }
        detailsDesktopImage: details_desktop_image {
          id
        }
      }
    }
  }
`
